import React from "react";
import { useForm } from "react-hook-form";
import PropTypes from "prop-types";

import { yupResolver } from "@hookform/resolvers/yup";
import { yup } from "utils";

import { passwordValidation } from "components/Form/ControlledPassword/ControlledPassword";

import {
  Button,
  Form,
  VerifyCodeInput,
} from "scenes/Authentication/components/ForgotPasswordManager/components";

export function ResetPasswordForm({ loading, onResendCode, onSubmit }) {
  const resetPasswordSchema = yup.object({
    code: yup.string().required("Verification code is required"),
    password: passwordValidation,
    passwordConfirmation: yup
      .string()
      .required("Password confirmation is required")
      .oneOf([yup.ref("password")], "The password you entered does not match"),
  });

  const formProps = useForm({
    resolver: yupResolver(resetPasswordSchema),
    defaultValues: { code: "", password: "", passwordConfirmation: "" },
    mode: "onSubmit",
    criteriaMode: "all",
  });

  return (
    <Form {...formProps} onSubmit={onSubmit}>
      <div style={{ marginTop: "22px", marginBottom: "22px" }}>
        <VerifyCodeInput onResendCode={onResendCode} disabled={loading} />
      </div>
      <Form.Password
        name="password"
        label="New Password"
        fluid
        placeholder="Create a password"
      />
      <div style={{ marginTop: "22px" }}>
        <Form.Password
          name="passwordConfirmation"
          label="Confirm Your Password"
          fluid
          showDefaultError={false}
          placeholder="Retype your password"
        />
      </div>
      <Button
        primary
        fluid
        loading={loading}
        disabled={loading}
        style={{ marginTop: "22px" }}
      >
        Reset Password
      </Button>
    </Form>
  );
}

ResetPasswordForm.propTypes = {
  loading: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  onResendCode: PropTypes.func.isRequired,
};

ResetPasswordForm.defaultProps = {
  loading: false,
};

export default ResetPasswordForm;
